module.exports = __webpack_public_path__ + "media/app/assets/races/mechagnome_female-18f1925d545c7353d9ef9f7580b6c00e.png";